import axios from 'axios';

import { BFF_PROXY_API } from 'constants/apiRoutes';

export const fetchRegions = async () => {
  let centers = [];

  const centersData = localStorage.getItem('centers');

  if (!centersData) {
    try {
      const { data: centersApi } = await axios.get(BFF_PROXY_API.getRegionalCenters);
      centers = centersApi;
      localStorage.setItem('centers', JSON.stringify(centersApi));
    } catch (e) {}
  } else {
    try {
      const parsedData = JSON.parse(centersData);
      if (Array.isArray(parsedData)) {
        centers = parsedData;
      } else if (Array.isArray(parsedData.data)) {
        centers = parsedData.data;
      }
    } catch (e) {}
  }

  return centers;
};
